import React, {useEffect, useState} from 'react';
import { Container, Line, Column, Text, NumberInput, StateIndicator, AlarmConfig, ContainerPump} from '../styles';
// import CriticoIcon from '../CriticoIcon';
// import AdvertenciaIcon from '../AdvertenciaIcon';
// import NonAlarm from '../NonAlarm';
// import Select from '../Select';
// import State from '../State';
// import ConfigIcon from '../ConfigIcon';
// import OperationModeTwo from '../OperationModeTwo';
import { CriticoIcon, AdvertenciaIcon, NonAlarm, Select, State, ConfigIcon, OperationModeTwo } from '../../Components';

/**
 * Componente para controle
 * @param {string} VariableName nome da variável
 * @param {string} PV String da segunda coluna "PV", "OUT"
 * @param {boolean} ReadOnly caso o valor não possa ser alterado
 * @param {Float} VariableValue valor da variável
 * @param {boolean} hasUnitConfig caso tenha configurações de unidades
 * @param {string} VariableUnit unidade da variável
 * @param {boolean} options Array com opções para unidades de medida ({value e label})
 * @param {boolean} hasSP caso tenha setpoint
 * @param {string} SP setpoint
 * @param {string} background 
 * @param {string} comand id do comando
 * @param {Function} addComand função para adicionar novo comando
 * @param {string} fatherName nome do elemento pai
 * @param {Object} Alarms elemento com os alarmes da variável
 * @param {Function} ShowAlarms função para exibir os alarmes
 * @param {boolean} isNewValue caso seja um novo valor inserido pelo usuário
 * @returns {ReactComponentElement} 
 */
const VariableComponent = ({id = [], active, VariableName, PV, ReadOnly, VariableValue, hasUnitConfig, VariableUnit, 
    options, hasSP, SP, background, comand, addComand, fatherName, Alarms, ShowAlarms, Alarm, type, isNewValue}) => {
    
    const [currentValue, setCurrentValue] = useState(VariableValue !== null ? VariableValue : 0);
    const [currentsp, setCurrentSp] = useState(SP !== null ? SP : 0);
    const [alarm, setAlarm] = useState(Alarm ? Alarm : 0);
    const [isAlarm, setIsAlarm] = useState(false);
    const [selectedValue, setSelectedValue] = useState(VariableUnit);

    const isAlarmMode = isAlarm === 'all' || isAlarm === 'h' || isAlarm === 'l';

    useEffect(() => {
        setCurrentValue(VariableValue !== null ? VariableValue : 0);
        setCurrentSp(SP !== null ? SP : 0)
    },[VariableValue, SP]);

    const changeSelect = (e) => {
        setSelectedValue(e.target.value)
    }

    // Função para constuir o comando e adiciona-lo a lista
    const ComandConstructor = (value, oldvalue, childName, cancelComand, type) => {
        let name = !type ? fatherName+'/'+childName : childName;
        addComand([comand, value], oldvalue, name, cancelComand, type);
    }
    
    // Função para pegar o nivel de alerta do alarme
    const getAlarm = (valor, l, ll, h, hh) => {
        if(ll != null && (hh === null || hh === undefined) && ll === l && ll !== 0){
            return 6
        }
        if(hh != null && (ll === null || ll === undefined) && hh === h && hh !== 0){
            return 6
        }
        if(hh === h && ll === l && hh === ll){
            return 6
        }
        if(ll != null && ll !== 0){
            if (parseFloat(valor) <= parseFloat(ll)){
                return 2;
            }
        }
        if(hh != null && hh !== 0){
            if (parseFloat(valor) >= parseFloat(hh)){
                return 2;
            }
        }
        if(l != null && l !== 0){
            if (parseFloat(valor) <= parseFloat(l)){
                return 1;
            }
        }
        if(h != null && h !== 0){
            if (parseFloat(valor) >= parseFloat(h)){
                return 1;
            }
        }
        return 0;
    }

    useEffect(()=>{
        if(Alarms.alarmHH && Alarms.alarmH && Alarms.alarmL && Alarms.alarmLL){
            let status = getAlarm(VariableValue, Alarms.alarmL.variavel.valor, 
                Alarms.alarmLL.variavel.valor, Alarms.alarmH.variavel.valor, Alarms.alarmHH.variavel.valor)
            setAlarm(status);
            setIsAlarm('all');
        }else if(Alarms.alarmHH && Alarms.alarmH){
            let status = getAlarm(VariableValue, null, 
                null, Alarms.alarmH.variavel.valor, Alarms.alarmHH.variavel.valor)
            setAlarm(status);
            setIsAlarm('h');
        }else if(Alarms.alarmLL && Alarms.alarmL){
            let status = getAlarm(VariableValue, Alarms.alarmL.variavel.valor, 
                Alarms.alarmLL.variavel.valor, null, null)
            setAlarm(status);
            setIsAlarm('l');
        }
        if(Alarm && Alarm > 2){
            setAlarm(Alarm)
        }
    }, [Alarms, Alarm]);

    // Função para exibir os alarmes vinculados ao item, caso haja alarmes
    const openAlarms= () => {
        if(isAlarm === 'all'){
            ShowAlarms(VariableName ,Alarms.alarmL.variavel, Alarms.alarmLL.variavel, Alarms.alarmH.variavel, Alarms.alarmHH.variavel);
        }else if(isAlarm === 'h'){
            ShowAlarms(VariableName, null, null, Alarms.alarmH.variavel, Alarms.alarmHH.variavel);
        }else if (isAlarm === 'l'){
            ShowAlarms(VariableName, Alarms.alarmL.variavel, Alarms.alarmLL.variavel, null, null);
        }
    }

    // Método para alterar o state
    const changeState = (newState) => {
        ComandConstructor(newState, VariableValue, VariableName, () => {setCurrentValue(VariableValue)}, 'state');
        setCurrentValue(newState);
    }

    // Método para alterar o modo de operação
    const changeOperationMode = (newState) => {
        ComandConstructor(newState, VariableValue, VariableName, () => {setCurrentValue(VariableValue)}, 'modo');
        setCurrentValue(newState);
    }

    return (
        <ContainerPump id={`${(isAlarmMode && active) && id?.[0]}`}>
            {isAlarmMode ?
                <AlarmConfig id="config" $isAlarm={isAlarmMode}  onClick={() => openAlarms()}>
                    <ConfigIcon/>
                </AlarmConfig> : <AlarmConfig/>
            }

            <Container 
                id={`${(isAlarmMode && active) && id?.[1]}`}
                $background={Alarms} 
                $alarm={alarm} 
                $isAlarm={isAlarmMode} 
                onDoubleClick={() => openAlarms()}>
                <Line>
                    <Column $align={'flex-start'} $width={'40%'}>
                        <Text>{VariableName}</Text>
                    </Column>
                    
                    <Column $width={'15%'}>
                        <Text>{PV}</Text>
                    </Column>

                    <Column $width={'20%'}>
                        {ReadOnly ? 
                            type === 'state' ?
                                <StateIndicator State={parseInt(currentValue)=== 1}>{parseInt(currentValue) === 1 ? 'L' : 'D'}</StateIndicator>
                            :
                            <Text $weight={'600'}>{VariableValue}</Text>
                        :   
                            type === 'state' ?
                                <State isNewValue={isNewValue} State={parseInt(currentValue) === 1} onChange={(newState) => changeState(newState)}/>
                            : type === 'operation' ?
                                <OperationModeTwo isNewValue={isNewValue} State={parseInt(currentValue) || parseInt(currentValue) === 0 ? parseInt(currentValue) : currentValue} onChange={(newState)=> changeOperationMode(newState)}/>
                            :                       
                                <NumberInput isNewValue={isNewValue} onBlur={()=>ComandConstructor(currentValue, VariableValue, VariableName, () => {setCurrentValue(VariableValue !== null ? VariableValue : 0)})} 
                                value={currentValue} type="number"
                                onChange={(e) => {setCurrentValue(e.target.value)}}/>
                        }
                    </Column>

                    <Column $width={'20%'}>
                        {hasUnitConfig ?
                            <Select options={options} value={selectedValue} onChange={changeSelect}/>               
                        :
                            <Text $weight={'600'}>{VariableUnit}</Text>
                        }
                    </Column>
                    <Column $width={'5%'}>
                        {alarm === 2 ? <CriticoIcon width={'10'} height={'10'}/> : 
                        alarm === 1 ? <AdvertenciaIcon width={'10'} height={'10'}/> : 
                        alarm === 6 ? <NonAlarm width={'10'} height={'10'}/> :
                        null}
                    </Column>
                </Line>
                {hasSP ? 
                    <Line>
                        <Column $width={'40%'}/>
                        <Column $width={'15%'}>
                            <Text>SP</Text>
                        </Column>
                        <Column $width={'20%'}>
                            <NumberInput  isNewValue={isNewValue} onBlur={() => ComandConstructor(currentsp, SP, 'SP', () => {setCurrentSp(SP !== null ? SP : 0)})} 
                            value={currentsp} type="number" onChange={(e) => {
                                setCurrentSp(e.target.value);
                            }}/>

                        </Column>
                        <Column $width={'20%'}>
                            <Text $weight={'600'}>{selectedValue}</Text>
                        </Column>
                        <Column $width={'5%'}/>
                    </Line>
                :
                    <></>}
            </Container>
        </ContainerPump>
    );
}

export default VariableComponent;